import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SiteDashboardService } from 'src/app/home/site-dashboard/site-dashboard.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { UsersService } from 'src/app/users/users.service';

@Component({
	selector: 'app-charglink-brm',
	templateUrl: './charglink-brm.component.html',
	styleUrls: ['./charglink-brm.component.css']
})
export class CharglinkBrmComponent implements OnInit, OnDestroy{
	activePage: string;
	siteId: number;
	customerId: number;
	hasBasicSetupPermission = false;
	permissionsLoaded = false;
	isDefaultEntry = false;
	permissionsSub: Subscription = new Subscription();

	constructor(
		public commonService: CommonService,
		private route: ActivatedRoute,
		public usersService: UsersService,
		private siteDashboardService: SiteDashboardService,
		private router: Router,
		private domainsService: DomainsService,
	) {}

	isProduction = false;

	ngOnInit() {
		if (!this.usersService.hasAccessFunction('show_charglink_brm'))
			return this.router.navigate(['/unauthorized']);

		this.isProduction = this.domainsService.isProductionDomain;
		this.siteId = this.route.parent.snapshot.params.siteId || 0;
		this.customerId = this.route.parent.snapshot.params.customerId || 0;

		this.permissionsSub = this.siteDashboardService.permissionsOfCurrentSite.subscribe(permissions => {
			if (!permissions || !Object.keys(permissions).length)
				return;

			this.permissionsLoaded = true;
			this.hasBasicSetupPermission = this.usersService.hasAccessPermission(permissions, 'basic_setup');
			this.resolveDefaultEntryPage();
			this.checkPublicRankingPageAccess();
		});
	}

	ngOnDestroy() {
		this.permissionsSub.unsubscribe();
	}

	ngAfterViewInit() {

		this.route.data.subscribe(params => {
			this.isDefaultEntry = !params.pageName || params.pageName == 'charglink-brm';

			if (this.isDefaultEntry)
				this.resolveDefaultEntryPage();
			else
				this.activePage = params.pageName;

			this.checkPublicRankingPageAccess();
		});
	}

	resolveDefaultEntryPage() {
		if (!this.isDefaultEntry || !this.permissionsLoaded)
			return;

		this.activePage = this.hasBasicSetupPermission ? 'public-ranking-page' : 'detailed-ranking-page';
	}

	checkPublicRankingPageAccess() {
		if (this.permissionsLoaded && this.activePage == 'public-ranking-page' && !this.hasBasicSetupPermission)
			this.router.navigate(['/unauthorized']);
	}

	isActiveTab(tab) {
		return this.activePage == tab;
	}
}
